import Image from "next/image";
import { MdArrowOutward } from "react-icons/md";

export interface AlternativesCardProps {
    id: string;
    imageUrl: string;
    title: string;
    imgAlt: string;
    externalLink: string;
}

export const AlternativesCards: React.FC<AlternativesCardProps> = ({ title, externalLink, imageUrl, imgAlt }) => {
    return (
        <a
            href={externalLink}
            rel="noopener noreferrer"
            className="flex flex-col justify-between h-full hover:shadow-xl mx-5 case-study-wrapper cursor-pointer bg-white hover:no-underline"
        >
            <Image src={imageUrl} width={397} height={332} alt={imgAlt} className="rounded-none" />
            <div className="flex flex-col flex-grow p-6 gap-3">
                <p className="text-xl text-gray-900 font-medium mb-4 hover-text-color">{title}</p>
                <span className="mt-auto w-full flex">
                    <MdArrowOutward size={20} className="case-study-icon ml-auto" color="black" />
                </span>
            </div>

            <style>{`
                      .case-study-wrapper {
                          border-bottom: 3px solid #CBD5E0;
                          transition: border-bottom 0.3s ease;
                      }
                      .case-study-wrapper:hover {
                          border-bottom: 3px solid #3364FA;
                      }
                      .case-study-icon {
                          transition: transform 0.3s ease, color 0.3s ease;
                      }
                      .case-study-wrapper:hover .case-study-icon {
                          transform: rotate(49deg);
                          color: red;
                      }
                      .hover-text-color {
                          transition: color 0.3s ease;
                      }
                      .case-study-wrapper:hover .hover-text-color {
                          color: #3364FA;
                      }
                      `}</style>
        </a>
    );
};
